import React from 'react';
import {MapPin, Calendar, Wifi, CheckCircle2, Euro, Clock2} from 'lucide-react';
import { aboutData } from '@/data/profile';
import AnimatedSection from './AnimatedSection';

const iconMap = {
  "Auto-entrepreneur depuis": Calendar,
  "Localisation": MapPin,
  "Mode de travail": Wifi,
  "Disponibilité": Clock2,
  "Idées concrétisées": CheckCircle2,
  "TJM": Euro
};

const About = () => {
  return (
    <section id="about" className="py-32 px-4 relative">
      <div className="max-w-6xl mx-auto">
        <AnimatedSection animation="fade-up">
          <div className="text-center mb-20 space-y-4">
            <h2 className="text-4xl md:text-5xl font-bold text-white">À Propos</h2>
            <p className="text-xl text-[#a0a0a0]">
              Passionné par l'excellence technique
            </p>
          </div>
        </AnimatedSection>
        
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Photo */}
          <AnimatedSection animation="scale" delay={200}>
            <div className="flex justify-center lg:justify-start">
              <div className="relative group">
                {/* Gradient glow behind photo */}
                <div className="absolute -inset-4 bg-gradient-to-br from-[#0066FF] via-[#7B61FF] to-[#FF4D8D] rounded-full blur-2xl opacity-30 group-hover:opacity-50 transition-opacity duration-500"></div>
                
                {/* Photo placeholder with gradient border */}
                <div className="relative w-64 h-64 rounded-full overflow-hidden border-4 border-transparent bg-gradient-to-br from-[#0066FF] via-[#7B61FF] to-[#FF4D8D] p-1 group-hover:scale-105 transition-transform duration-500">
                  <div className="w-full h-full rounded-full bg-[#1a1a1a] flex items-center justify-center">
                    <div className="text-6xl font-bold bg-gradient-to-br from-[#0066FF] to-[#7B61FF] text-transparent bg-clip-text">
                      PI
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </AnimatedSection>
          
          {/* Bio and info */}
          <div className="space-y-8">
            <AnimatedSection animation="fade-left" delay={300}>
              <p className="text-md text-[#e0e0e0] font-light leading-relaxed">
                {aboutData.bio}
              </p>
            </AnimatedSection>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {aboutData.info.map((item, index) => {
                const Icon = iconMap[item.label] || CheckCircle2;
                const gradients = [
                  'from-[#0066FF] to-[#7B61FF]',
                  'from-[#7B61FF] to-[#FF4D8D]',
                  'from-[#00D4FF] to-[#0066FF]',
                  'from-[#0066FF] to-[#00D4FF]',
                  'from-[#FF4D8D] to-[#7B61FF]'
                ];
                const gradient = gradients[index % gradients.length];
                
                return (
                  <AnimatedSection key={item.label} animation="fade-up" delay={400 + index * 100}>
                    <div className="group bg-[#1a1a1a] rounded-xl p-5 border border-[#2a2a2a] hover:border-transparent transition-all duration-500 cursor-pointer relative overflow-hidden hover:-translate-y-1">
                      <div className={`absolute inset-0 bg-gradient-to-br ${gradient} opacity-0 group-hover:opacity-10 transition-opacity duration-500`}></div>
                      
                      <div className="relative z-10 space-y-3">
                        <div className="flex items-center gap-3">
                          <div className={`w-10 h-10 bg-gradient-to-br ${gradient} rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-500 shadow-md`}>
                            <Icon className="w-5 h-5 text-white" />
                          </div>
                          <span className="text-xs text-[#a0a0a0] font-medium uppercase tracking-wide">{item.label}</span>
                        </div>
                        <p className="text-white font-semibold text-lg ml-13">{item.value}</p>
                      </div>
                    </div>
                  </AnimatedSection>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;